import { useEffect } from "react";
import {
  LoaderFunctionArgs,
  redirect,
  useLoaderData,
  useNavigate,
  useRouteError,
} from "react-router-dom";

import "./styles.css";
import GenericErrorDisplay from "../generic-error";
import ResourceDisplay from "../../components/resource-display";
import ResourceService from "../../service/resource";
import OutputResource from "../../dtos/resource";

const paramName = "ref";
export const path = "/redirect/";

export function externalRedirect(ref: string) {
  return redirect(externalRedirectUrl(ref));
}

export function externalRedirectUrl(ref: string) {
  const searchParams = new URLSearchParams();
  searchParams.set(paramName, ref);
  return `${path}?${searchParams.toString()}`;
}

export function useRedirect() {
  const navigate = useNavigate();

  return (ref: string) => navigate(externalRedirectUrl(ref));
}

const resourceKeys = {
  title: "redirect-title",
  image: "redirect-image",
};

export async function loader({ request }: LoaderFunctionArgs) {
  const resourcesPromise = new ResourceService().read.byIds(
    Object.values(resourceKeys)
  );

  const url = new URL(request.url);
  const ref = url.searchParams.get(paramName);
  if (ref === undefined || ref === null)
    throw new TypeError("Invalid reference for redirect.");
  return [ref, await resourcesPromise];
}

export function Component() {
  const [ref, resources] = useLoaderData() as [
    string,
    {
      [key: string]: OutputResource;
    }
  ];
  const navigate = useNavigate();
  useEffect(() => window.location.replace(ref), [ref, navigate]);

  return (
    <div id="redirect-page">
      <div className="content-container container">
        <div className="text-container">
          <ResourceDisplay
            resource={resources[resourceKeys.title]}
            wrapper="h2"
          />
          <div>{ref}</div>
        </div>
        <ResourceDisplay
          resource={resources[resourceKeys.image]}
          className="image"
        />
      </div>
    </div>
  );
}
Component.displayName = "Component";

export function ErrorBoundary() {
  const error = useRouteError();
  return <GenericErrorDisplay error={error} />;
}
ErrorBoundary.displayName = "ErrorBoundary";
